module.exports = __webpack_public_path__ + "img/Accesory.c7dcf842.jpg";